// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from './Modal';

export default class RenameDocument extends Modal {

    state = {
        name: "",
        alert: false
    }

    componentDidMount = () => {
        this.setCurrentName(this.props.data);
    }

    componentWillReceiveProps = (next) => {
        if (next.data !== this.props.data)
            this.setCurrentName(next.data);
    }

    setCurrentName = (data) => {
        this.setState({ name: data && data.name ? data.name : "" });
        setTimeout(() => {
            const input = document.getElementById("filename")
            input.focus();
            input.select();
        }, 150);
    }

    renameDocument = async (e) => {

        e.preventDefault();
        e.stopPropagation();

        const name = this.state.name;

        if (!this.state.name || this.state.name === "")
            return this.alert();

        await this.setState({ name: "" });
        await this.props.modal();
        await this.props.updateDocument(this.props.data._id, { name });

    }

    renderContent = () => {

        return (<div className="modal-content modal-center">
            
            <div style={{
                height: 150
            }} />

            <h1>Rename your document</h1>

            <p>Enter the new filename for the document and hit the <strong>Submit</strong> button to confirm.</p>

            <br />

            <form
                onSubmit={this.renameDocument}
            >

            <input
                id="filename"
                name="filename"
                type="text"
                className={"input-inline-text" + (this.state.alert ? " input-error" : "")}
                placeholder="Enter new filename..."
                style={{ width: 330 }}
                value={this.state.name}
                onClick={e => e.stopPropagation()}
                onChange={e => this.setState({ name: e.target.value, alert: false })}
            />

            <input
                type="submit"
                value="Submit"
                className="input-inline-submit"
            />
            
            </form>
            
        </div>);
    }

};